import { ElMessage } from 'element-plus'
import SuccessIcon from './svgIcon/SuccessIcon.vue'
import ErrorIcon from './svgIcon/ErrorIcon.vue'
import WarningIcon from './svgIcon/WarningIcon.vue'

function getClassName(type) {
  switch (type) {
    case 'success':
      return 'el-message--success'
    case 'warning':
      return 'el-message--warning'
    case 'info':
      return 'el-message--info'
    case 'error':
      return 'el-message--error'
    default:
      return 'el-message--info'
  }
}

function showMsg(message, type, duration = 3000, icon, showClose = false) {
  ElMessage({
    message,
    type,
    duration,
    customClass: 'msg-global ' + getClassName(type),
    icon: icon,
    showClose: showClose
  })
}

export default {
  e(parameter) {
    showMsg(
      parameter.msg,
      'error',
      parameter.duration,
      parameter.icon ? parameter.icon : ErrorIcon,
      parameter.showClose
    )
  },
  s(parameter) {
    showMsg(
      parameter.msg,
      'success',
      parameter.duration,
      parameter.icon ? parameter.icon : SuccessIcon,
      parameter.showClose
    )
  },
  i(parameter) {
    showMsg(
      parameter.msg,
      'warning',
      parameter.duration,
      parameter.icon ? parameter.icon : WarningIcon,
      parameter.showClose
    )
  }
}
